import { createAiChatHttpClient } from './httpClient';
import { chatbotConfigByModuleId } from './paths';
import { getAiChatApiBase } from '../config';

/**
 * @typedef {{
 *   id?: string,
 *   agentId?: string,
 *   projectId?: string,
 *   moduleId?: string,
 *   lakehouseSQLEndpoint?: string,
 *   lakehouseName?: string,
 *   visibility?: string[] | string,
 *   customInstruction?: string,
 *   introMessage?: string,
 *   agent?: { id?: string, name?: string, displayName?: string },
 * }} ChatbotConfigDto
 */

/**
 * GET /chatbot/config/:moduleId. Returns null when no config exists (404).
 *
 * @param {string} moduleId
 * @returns {Promise<ChatbotConfigDto | null>}
 */
export async function fetchChatbotConfig(moduleId) {
  if (!moduleId || !getAiChatApiBase()) {
    return null;
  }
  const client = createAiChatHttpClient();
  if (!client) {
    return null;
  }
  try {
    const { data } = await client.get(chatbotConfigByModuleId(moduleId));
    if (!data || typeof data !== 'object') {
      return null;
    }
    return data;
  } catch (e) {
    if (e?.response?.status === 404) {
      return null;
    }
    throw e;
  }
}
